// extracted by mini-css-extract-plugin
export default {"closeBtn":"success_closeBtn__ncRlq","errorPopup":"success_errorPopup__jbWQ+"};